"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Languages_1 = __importDefault(require("../Languages"));
var ProfileMenuList_1 = __importDefault(require("../ProfileMenuList"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AuthProfileMenu = function (_a) {
    var _b, _c, _d;
    var languages = _a.languages, _e = _a.withReferral, withReferral = _e === void 0 ? true : _e, promoLink = _a.promoLink;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tLang = (0, next_intl_1.useTranslations)('languages');
    var lang = (0, next_intl_1.useLocale)();
    var openManager = (0, common_hooks_1.usePremiumSupport)().openManager;
    var _f = (0, swr_hooks_1.usePlayerStatus)(), isLoading = _f.isLoading, currentLevelInfo = _f.currentLevelInfo, progressPercents = _f.progressPercents, nextLevelInfo = _f.nextLevelInfo, userPoints = _f.userPoints, nextLevelMin = _f.nextLevelMin;
    var playerName = (0, swr_hooks_1.usePlayerName)();
    var signOut = (0, swr_hooks_1.useSignOut)().signOut;
    var config = (0, swr_hooks_1.useConfig)();
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var signOutHandler = (0, react_1.useCallback)(function () {
        signOut();
        closeWindow();
    }, [closeWindow, signOut]);
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var data = (0, swr_hooks_1.useBalance)().data;
    var secondaryMenuList = (0, react_1.useMemo)(function () {
        var defaultList = [
            {
                label: t('tournaments'),
                icon: '/img/profileMenu/tournaments.svg',
                href: generateUrlWithLang('/tournaments'),
            },
            {
                label: t('favorites'),
                icon: '/img/profileMenu/favorites.svg',
                href: generateUrlWithLang('/games/favorites'),
            },
            {
                label: t('bonuses'),
                icon: '/img/profileMenu/megaphone.svg',
                href: generateUrlWithLang('/promotions'),
            },
            {
                label: t('payments'),
                icon: '/img/profileMenu/bank.svg',
                href: generateUrlWithLang('/payments'),
            },
            {
                label: t('vipclub'),
                icon: '/img/profileMenu/vip.svg',
                href: generateUrlWithLang('/vip'),
            },
        ];
        return promoLink
            ? __spreadArray([
                {
                    label: t('promo'),
                    icon: '/img/promo/bonusIcon.svg',
                    href: generateUrlWithLang(promoLink),
                }
            ], defaultList, true) : defaultList;
    }, [promoLink, t, generateUrlWithLang]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        !isLoading && (react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", { style: { marginRight: '20px' } },
                react_1.default.createElement(ui_components_1.ProgressAvatar, { progressPercents: progressPercents, currentLevel: (currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) || 0, statusName: (currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.name) || '', image: ((_b = currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.images) === null || _b === void 0 ? void 0 : _b.big) || apps_shared_1.userLevelsImages.level0Default })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.headerBlock },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.headerContent },
                    playerName,
                    " ",
                    react_1.default.createElement("div", null, t('nextStatus'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.headerStatus }, nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.name),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.progress },
                    userPoints,
                    "/",
                    nextLevelMin,
                    " (",
                    progressPercents,
                    "%)"),
                withReferral && react_1.default.createElement(ui_components_1.ReferralLink, null)))),
        react_1.default.createElement(ProfileMenuList_1.default, { haveBalance: true, items: (config === null || config === void 0 ? void 0 : config.liveChatShouldDisabled)
                ? [
                    {
                        label: t('balance'),
                        icon: '/img/profileMenu/balance.svg',
                        balance: data
                            ? "".concat((0, apps_shared_1.getCurrencySymbol)(data === null || data === void 0 ? void 0 : data.currency), " ").concat((_c = Number(data === null || data === void 0 ? void 0 : data.totalAmount)) === null || _c === void 0 ? void 0 : _c.toFixed(2))
                            : '',
                        button: (react_1.default.createElement("div", { className: styles_module_scss_1.default.depositBtnWrapper },
                            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "200px", text: "upper", onClick: openDeposit }, t('deposit')))),
                    },
                    {
                        label: t('myAccount'),
                        icon: '/img/profileMenu/profile.svg',
                        href: generateUrlWithLang('/account/wallet/balance'),
                    },
                    {
                        label: tLang(lang),
                        icon: '/img/profileMenu/globe.svg',
                        dropdown: react_1.default.createElement(Languages_1.default, { languages: languages }),
                    },
                ]
                : [
                    {
                        label: t('balance'),
                        icon: '/img/profileMenu/balance.svg',
                        balance: data
                            ? "".concat((0, apps_shared_1.getCurrencySymbol)(data === null || data === void 0 ? void 0 : data.currency), " ").concat((_d = Number(data === null || data === void 0 ? void 0 : data.totalAmount)) === null || _d === void 0 ? void 0 : _d.toFixed(2))
                            : '',
                        button: (react_1.default.createElement("div", { className: styles_module_scss_1.default.depositBtnWrapper },
                            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "200px", text: "upper", onClick: openDeposit }, t('deposit')))),
                    },
                    {
                        label: t('myAccount'),
                        icon: '/img/profileMenu/profile.svg',
                        href: generateUrlWithLang('/account/wallet/balance'),
                    },
                    {
                        label: t('supportChat'),
                        icon: '/img/profileMenu/chat.svg',
                        onClick: openManager,
                    },
                    {
                        label: tLang(lang),
                        icon: '/img/profileMenu/globe.svg',
                        dropdown: react_1.default.createElement(Languages_1.default, { languages: languages }),
                    },
                ] }),
        react_1.default.createElement(ProfileMenuList_1.default, { secondary: true, items: secondaryMenuList }),
        react_1.default.createElement(ProfileMenuList_1.default, { items: [
                {
                    label: t('signOut'),
                    icon: '/img/profileMenu/signout.svg',
                    onClick: signOutHandler,
                },
            ] })));
};
exports.default = AuthProfileMenu;
